<template>
  <div class="rsf-table-cell col-12">
    <p class="open-sans-var h5 color-black center">{{
      measurement == 'metric' && metricValue && metricValue != '' ?  (Number(metricValue.replace(/,/g, '.')) * 10) + '' + metricSuffix
      :
      imperialValue && imperialValue != '' ? imperialValue + imperialSuffix
      : '-'
    }}</p>
  </div>

</template>

<script>

export default {
  name: 'CalcCell',
  props: {
    measurement: String,
    metricValue: String,
    metricSuffix: String,
    imperialValue: String,
    imperialSuffix: String
  }
}
</script>
